/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Profile_Devices_SubtitleInputs */

const es_user_profile_devices_subtitle = /** @type {(inputs: User_Profile_Devices_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dispositivos actualmente conectados a tu cuenta`)
};

const en_user_profile_devices_subtitle = /** @type {(inputs: User_Profile_Devices_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Devices currently signed into your account`)
};

/**
* | output |
* | --- |
* | "Devices currently signed into your account" |
*
* @param {User_Profile_Devices_SubtitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const user_profile_devices_subtitle = /** @type {((inputs?: User_Profile_Devices_SubtitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Profile_Devices_SubtitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_user_profile_devices_subtitle(inputs)
	return en_user_profile_devices_subtitle(inputs)
});
export { user_profile_devices_subtitle as "user.profile.devices.subtitle" }